let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5mIKg")).then(() => parcelRequire('3NuTN'));